import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function IadePolitikasiPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              İade Politikası
            </h1>

            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Genel Bilgiler</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p className="mb-4">
                    <strong>Emin Kuyumculuk</strong> olarak müşteri memnuniyeti bizim için önceliklidir. 
                    İade süreçlerimiz Tüketici Hakları Mevzuatı çerçevesinde düzenlenmiştir.
                  </p>
                  <div className="space-y-2 text-sm">
                    <p><strong>İletişim:</strong></p>
                    <p>Adres: Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                    <p>Telefon: 0531 603 68 91</p>
                    <p>E-posta: info@eminkuyumculuk.com.tr</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">İade Koşulları</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-400">
                    <h3 className="font-semibold text-green-800 mb-2">İade Edilebilir Durumlar</h3>
                    <ul className="list-disc list-inside text-sm text-green-700 space-y-1">
                      <li>Ürün hasarlı/kırık gelmiş</li>
                      <li>Yanlış ürün gönderilmiş</li>
                      <li>Ürün açıklamaya uymuyor</li>
                      <li>Kalite sorunu mevcut</li>
                      <li>14 günlük cayma hakkı</li>
                    </ul>
                  </div>
                  
                  <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-400">
                    <h3 className="font-semibold text-red-800 mb-2">İade Edilemez Durumlar</h3>
                    <ul className="list-disc list-inside text-sm text-red-700 space-y-1">
                      <li>Özel sipariş ürünler</li>
                      <li>Kişiye özel gravürlü ürünler</li>
                      <li>Hijyen gerektiren ürünler</li>
                      <li>Değeri düşmüş ürünler</li>
                      <li>14 günü geçmiş ürünler</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">İade Süreci</h2>
                <div className="space-y-6">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-800 mb-2">1. İade Talebi</h3>
                        <p className="text-sm text-gray-600">
                          İade talebinizi telefon, e-posta veya web sitemizden iletebilirsiniz. 
                          Sipariş numaranızı ve iade nedenini belirtiniz.
                        </p>
                      </div>
                      <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center ml-4">
                        <i className="ri-file-list-3-line text-2xl text-gold-600"></i>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-800 mb-2">2. Onay ve Kargo</h3>
                        <p className="text-sm text-gray-600">
                          İade talebiniz onaylandıktan sonra size iade kargo kodu gönderilir. 
                          Ürünü orijinal ambalajında kargoya veriniz.
                        </p>
                      </div>
                      <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center ml-4">
                        <i className="ri-truck-line text-2xl text-gold-600"></i>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-800 mb-2">3. İnceleme</h3>
                        <p className="text-sm text-gray-600">
                          Ürün tarafımıza ulaştığında kalite kontrol birimimizce incelenir. 
                          İnceleme süresi maksimum 3 iş günüdür.
                        </p>
                      </div>
                      <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center ml-4">
                        <i className="ri-search-line text-2xl text-gold-600"></i>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-800 mb-2">4. İade Tamamlama</h3>
                        <p className="text-sm text-gray-600">
                          İade onaylandığında ödeme iadesi 3-5 iş günü içinde hesabınıza yapılır. 
                          Kredi kartı ödemeleri 1-2 ekstre döneminde iade edilir.
                        </p>
                      </div>
                      <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center ml-4">
                        <i className="ri-money-dollar-circle-line text-2xl text-gold-600"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">İade Şartları</h2>
                <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                  <h3 className="font-semibold text-amber-800 mb-3">Dikkat Edilmesi Gerekenler</h3>
                  <ul className="space-y-2 text-sm text-amber-700">
                    <li><strong>Süre:</strong> Ürünü teslim aldığınız tarihten itibaren 14 gün içinde iade talebinde bulunabilirsiniz.</li>
                    <li><strong>Ambalaj:</strong> Ürün orijinal ambalajında, etiketli ve hiç kullanılmamış olmalıdır.</li>
                    <li><strong>Fatura:</strong> İade edilecek ürün faturası ile birlikte gönderilmelidir.</li>
                    <li><strong>Kargo:</strong> İade kargo ücreti tarafımızca karşılanır (hatalı teslimat durumunda).</li>
                    <li><strong>İncelemesiz İade:</strong> Müşteri kusuru olmayan durumlar için ön inceleme yapmadan iade alınır.</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Ödeme İadesi</h2>
                <div className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg text-center">
                      <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-bank-card-line text-2xl text-gold-600"></i>
                      </div>
                      <h4 className="font-medium text-gray-800 mb-1">Kredi Kartı</h4>
                      <p className="text-xs text-gray-600">1-2 ekstre dönemi</p>
                    </div>

                    <div className="bg-gray-50 p-4 rounded-lg text-center">
                      <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-bank-line text-2xl text-gold-600"></i>
                      </div>
                      <h4 className="font-medium text-gray-800 mb-1">Havale/EFT</h4>
                      <p className="text-xs text-gray-600">3-5 iş günü</p>
                    </div>

                    <div className="bg-gray-50 p-4 rounded-lg text-center">
                      <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-hand-coin-line text-2xl text-gold-600"></i>
                      </div>
                      <h4 className="font-medium text-gray-800 mb-1">Kapıda Ödeme</h4>
                      <p className="text-xs text-gray-600">Havale ile iade</p>
                    </div>
                  </div>

                  <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
                    <p className="text-sm text-blue-800">
                      <strong>Bilgi:</strong> İade tutarı, ürünün orijinal satış fiyatı üzerinden hesaplanır. 
                      Kullanılan indirim kuponları ve promosyonlar iade tutarından düşülür.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Değişim Politikası</h2>
                <div className="space-y-4">
                  <p>
                    <strong>Beden/Model Değişimi:</strong> Satın aldığınız üründe beden veya model 
                    değişikliği yapmak istiyorsanız, ürünü iade ederek yeni sipariş verebilirsiniz.
                  </p>
                  <p>
                    <strong>Fark Ödemesi:</strong> Değişim yapacağınız üründe fiyat farkı varsa, 
                    eksik tutarı ödeyebilir veya fazla tutarı iade alabilirsiniz.
                  </p>
                  <p>
                    <strong>Stok Durumu:</strong> Değişim talep ettiğiniz ürün stokta mevcut olmalıdır. 
                    Stok yoksa iade işlemi gerçekleştirilir.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Özel Durumlar</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-3">Hasarlı Teslimat</h3>
                    <ul className="list-disc list-inside text-sm space-y-1">
                      <li>Kargo teslim anında hasarı tespit edin</li>
                      <li>Kargo firması tutanağa hasar kaydettirin</li>
                      <li>Derhal bizimle iletişime geçin</li>
                      <li>Hasarın fotoğrafını çekip gönderin</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-3">Yanlış Ürün</h3>
                    <ul className="list-disc list-inside text-sm space-y-1">
                      <li>Siparişinizi kontrol edin</li>
                      <li>Yanlışlığı derhal bildirin</li>
                      <li>Doğru ürün hemen gönderilir</li>
                      <li>Yanlış ürünün kargosunu karşılarız</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">İletişim Kanalları</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-gold-50 p-4 rounded-lg text-center">
                    <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-phone-line text-2xl text-gold-600"></i>
                    </div>
                    <h4 className="font-medium text-gray-800 mb-2">Telefon</h4>
                    <p className="text-sm text-gray-600">0531 603 68 91</p>
                    <p className="text-xs text-gray-500">Pzt-Cmt 09:00-19:00</p>
                  </div>

                  <div className="bg-gold-50 p-4 rounded-lg text-center">
                    <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-mail-line text-2xl text-gold-600"></i>
                    </div>
                    <h4 className="font-medium text-gray-800 mb-2">E-posta</h4>
                    <p className="text-sm text-gray-600">info@eminkuyumculuk.com.tr</p>
                    <p className="text-xs text-gray-500">24 saat içinde yanıt</p>
                  </div>

                  <div className="bg-gold-50 p-4 rounded-lg text-center">
                    <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-map-pin-line text-2xl text-gold-600"></i>
                    </div>
                    <h4 className="font-medium text-gray-800 mb-2">Mağaza</h4>
                    <p className="text-sm text-gray-600">Keçiören / ANKARA</p>
                    <p className="text-xs text-gray-500">Randevu ile</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Sıkça Sorulan Sorular</h2>
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-800 mb-2">İade kargo ücreti kim öder?</h4>
                    <p className="text-sm text-gray-600">
                      Ürün hatası durumunda kargo ücreti tarafımızca karşılanır. 
                      Müşteri kaynaklı iadeler için kargo ücreti müşteriye aittir.
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-800 mb-2">İade süresi ne kadar?</h4>
                    <p className="text-sm text-gray-600">
                      Ürünü teslim aldığınız tarihten itibaren 14 gün içinde iade edebilirsiniz.
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-800 mb-2">Özel sipariş ürünler iade edilebilir mi?</h4>
                    <p className="text-sm text-gray-600">
                      Özel sipariş ve kişiye özel gravürlü ürünler iade edilemez. 
                      Sadece üretim hatası durumunda değişim yapılır.
                    </p>
                  </div>
                </div>
              </section>

              <div className="bg-gold-50 p-6 rounded-lg">
                <p className="text-center text-sm text-gray-600">
                  <strong>Müşteri Memnuniyeti Garantimiz:</strong><br />
                  Emin Kuyumculuk olarak müşteri memnuniyetiniz bizim önceliğimizdir. 
                  Herhangi bir sorun yaşamanız halinde çözüm odaklı yaklaşımla size yardımcı oluyoruz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}